import { z } from 'zod';

export const darwinDrawerSessionSchema = z
  .object({
    browserTabId: z.number().int().nonnegative(),
    organizationId: z.string().min(1),
    darwinPropertyId: z.number().int().positive(),
    ingestionFolderUuid: z.string().min(1),
  })
  .strict();

export const darwinDrawerSelectionSchema = z
  .object({
    ingestionDocumentUuid: z.string().min(1),
    contractDocumentUuid: z.string().min(1).optional(),
    uploadedPageNumber: z.number().int().positive().optional(),
    activeFieldId: z.string().min(1).optional(),
    activeFieldMessage: z.string().min(1).optional(),
    mappingKeys: z.array(z.string().min(1)).optional(),
    requestSequence: z.number().int().nonnegative(),
  })
  .strict();

const selectionCommandSchema = <T extends string>(type: T) =>
  z
    .object({
      type: z.literal(type),
      session: darwinDrawerSessionSchema,
      selection: darwinDrawerSelectionSchema,
    })
    .strict();

export const darwinDrawerCommandSchema = z.discriminatedUnion('type', [
  selectionCommandSchema('OPEN_DOCUMENT'),
  selectionCommandSchema('OPEN_VALIDATION_EVIDENCE'),
  selectionCommandSchema('OPEN_KEY_TERM_EVIDENCE'),
  selectionCommandSchema('UPDATE_SELECTION'),
  z
    .object({
      type: z.literal('CLOSE'),
      session: darwinDrawerSessionSchema,
      requestSequence: z.number().int().nonnegative(),
    })
    .strict(),
]);

export type DarwinDrawerCommand = z.infer<typeof darwinDrawerCommandSchema>;
export type DarwinDrawerSelection = z.infer<typeof darwinDrawerSelectionSchema>;
export type DarwinDrawerSession = z.infer<typeof darwinDrawerSessionSchema>;
